/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SessionIcon
 */
export default class SessionIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 1a3 3 0 013 3v9a3 3 0 01-3 3h-4.85l4.596 5.349a1 1 0 01-.016 1.322l-.09.088a1 1 0 01-1.323-.017l-.088-.09L13 17.731v4.27a1 1 0 01-.883.993L12 23a1 1 0 01-.993-.883L11 22v-4.317L6.758 22.62a1 1 0 11-1.516-1.304L9.809 16H5a3 3 0 01-3-3V4a3 3 0 013-3h14zm1 6.034H4V13a1 1 0 001 1h14a1 1 0 001-1V7.034zM19 3H5a1 1 0 00-1 1v1.034h16V4a1 1 0 00-1-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

